<div class="card">
  <div class="card-body" [ngClass]="defineLoanScheme()">
    <div class="d-flex justify-content-between flex-wrap">
      <div class="d-flex justify-content-start">
        <div class="badge rounded-pill text-bg-secondary" [hidden]="isEditing == true">Code: {{ loan.LoanCode }}</div>
        @if (sharedService.isRoles([enums.BRANCH_MANAGER, enums.BOOKKEEPING_STAFF, enums.STAFF])) {
          <input class="m-0 form-control" type="text" name="loanCode" [(ngModel)]="loan.LoanCode" [hidden]="isEditing == false" />
          <button class="btn btn-info ms-1 d-none d-md-inline" (click)="changeIsEditing(true)" [hidden]="isEditing == true || isSharedLoan() == true">
            <i class="fas fa-pencil-alt"></i>
          </button>
          <button class="btn btn-danger ms-1" (click)="changeIsEditing(false)" [hidden]="isEditing == false">
            <i class="fas fa-times"></i>
          </button>
          <button class="btn btn-success ms-1" [hidden]="isEditing == false" (click)="updateLoan()">
            <i class="fas fa-check"></i>
          </button>
        }
      </div>
      <div class="d-flex justify-content-end gap-2">
        <!-- <button class="btn btn-dark me-2" (click)="openViewLoanDocsModal(loan.ID)" placement="top"
        ngbTooltip="View Loan Documents" *ngIf="loan.LoanDocExisted == true && sharedService.isStaff()==false"><i class="fas fa-paperclip"></i></button> -->
        @if (isSharedLoan() === true) {
          <span class="badge text-bg-primary fs-5"><i class="far fa-handshake"></i>{{ loan.CompanyCode }}</span>
        }
        <!-- <div class="badge float-end me-2"
        [ngClass]="{'text-bg-dark':loan.Scheme=='EPF','text-bg-info':loan.Scheme!='EPF'}" style="cursor:pointer"
        *ngIf="loan.LoanDocExisted == false && isSimplifiedView==false && (sharedService.isBranchAccountHandler()  || sharedService.isBookkeepingStaff()) && isSharedLoan()==false "
        (click)="openUploadLoanDocModal(loan.ID)">
        <i class="fas fa-file-upload"></i> Add Payout Slip
      </div> -->
        @if (isSimplifiedView === false && isSharedLoan() === false) {
          @if (sharedService.isRoles([enums.BRANCH_MANAGER, enums.BOOKKEEPING_STAFF])) {
            <div class="btn-group">
              @if (loan.LoanDocExisted === true || loan.HasStampedFormJ === true) {
                <button class="btn fw-bold fs-5" [ngClass]="loan.Scheme === 'EPF' ? 'btn-dark' : 'btn-info'" (click)="openViewLoanDocsModal(loan.ID)"><i class="fas fa-file-upload"></i> Loan Doc</button>
                <button [ngClass]="loan.Scheme === 'EPF' ? 'btn-dark' : 'btn-info'" class="btn dropdown-toggle dropdown-toggle-split fs-5" data-bs-toggle="dropdown" aria-expanded="false">
                  <span class="visually-hidden">Toggle Dropdown</span>
                </button>
              } @else {
                <button class="btn fw-bold dropdown-toggle fs-5" [ngClass]="loan.Scheme === 'EPF' ? 'btn-dark' : 'btn-info'" data-bs-toggle="dropdown" aria-expanded="false"><i class="fas fa-file-upload"></i> Add Loan Doc</button>
              }
              <ul class="dropdown-menu">
                <li (click)="openUploadLoanDocModal(loan.ID)">
                  <a class="dropdown-item"><i class="fas fa-check text-success" [ngClass]="{ 'opacity-0': !loan.LoanDocExisted }"></i> Payout Slip</a>
                </li>
                @if (loan.FormJ !== undefined) {
                  <li (click)="openUploadStampedFormJ()">
                    <a class="dropdown-item"><i class="fas fa-check text-success" [ngClass]="{ 'opacity-0': !loan.HasStampedFormJ }"></i> Stamped Form J</a>
                  </li>
                }
              </ul>
            </div>
          } @else if (sharedService.isRoles([enums.BOSS, enums.FINANCE, enums.ADMIN, enums.BRANCH_MANAGER_HEAD, enums.ADMIN_HEAD, enums.AUDITOR, enums.EXPENSE_ADMIN])) {
            <button class="btn fw-bold fs-5" [ngClass]="loan.Scheme === 'EPF' ? 'btn-dark' : 'btn-info'" (click)="openViewLoanDocsModal(loan.ID)"><i class="fas fa-paperclip"></i> Loan Doc</button>
          }
        }
        @if (loan.IsPendingCommission === true && isSimplifiedView === false && sharedService.isRoles([enums.BRANCH_MANAGER, enums.BOOKKEEPING_STAFF, enums.STAFF]) && selectedProfile.SharedProfileId == selectedProfile.ID) {
          <span class="badge rounded-pill text-bg-danger fs-5 align-middle">No Commission</span>
        }
        @if (loan.Scheme === SCHEME.A) {
          <span class="badge rounded-pill text-bg-info fs-5">{{ loan.InterestRate }}</span>
        }
        <span class="badge rounded-pill text-bg-light fs-5"
          >{{ loan.ReceiptNumber }}
          @if (loan.Scheme === SCHEME.EPF) {
            (EPF)
          }
        </span>
        <span class="badge rounded-pill" [ngClass]="'text-' + getStatusColor(loan.Status)">{{ getLoanStatus(loan.Status) }}</span>
      </div>
    </div>

    <div class="d-grid grid-md-2-col gap-3 row-gap-4 my-4">
      <div>
        <i class="far fa-calendar-minus"></i> Registered Date:
        <div class="fw-bold">{{ loan.DateCreated | date: "dd-MM-yyyy" }}</div>
      </div>
      <div>
        <i class="fas fa-money-bill-wave"></i> Loan Amount:
        <div class="fw-bold">
          RM {{ loan.Principal }}
          @if (loan.Scheme !== SCHEME.A) {
            <span class="text-danger">| Total: RM {{ loanTotalIncludeInterest | number: "1.0-2" }}</span>
          }
        </div>
        @if (sharedService.isRoles([enums.BRANCH_MANAGER, enums.BOOKKEEPING_STAFF, enums.STAFF]) && loan.Scheme === SCHEME.A && isCP(loan.Status) == false && isBadDebt(loan.Status) == false && isSettled(loan.Status) == false && loan.IsEPF == false && needRestrictionCustomer == false) {
          <button class="btn btn-primary ms-2" (click)="openAddPrincipalModal(loan)">
            <i class="fas fa-plus"></i>
          </button>
        }
      </div>
      @if ((isSimplifiedView == false || loan.Scheme === SCHEME.P) && loan.Scheme !== SCHEME.HUTANG) {
        <div>
          <i class="fas fa-table"></i> Tenure: <span class="fw-bold">{{ loan.Term }} month(s)</span>
        </div>
        <div>
          <i class="fas fa-calendar-check"></i> Monthly:
          <span class="fw-bold">RM{{ loan.MonthlyPayment | number: "1.2-2" }}</span>
          <span class="fw-bold text-primary">
            @if (loan.IsEPF === true && loan.LegacySettlement !== undefined) {
              | <i class="fas fa-money-check-alt"></i> : RM{{ loan.LegacySettlement | number: "1.0-0" }}
            }
            @if (loan.Scheme === "EPF") {
              | <i class="fas fa-money-check-alt"></i> : RM{{ sharedService.calculateEPFSettlementAmountWithCharges(loan) | number: "1.0-2" }}
              <i class="far fa-question-circle ms-2" placement="top" [ngbTooltip]="settlementDetailsTooltip" style="cursor: pointer"></i>
            }
          </span>

          @if (sharedService.isBossAccount() == true && loan.HasSettlementChargesObj && (sharedService.checkIsWholeNumber(loan.SettlementCharges.Extras) == false || sharedService.checkIsWholeNumber(loan.SettlementCharges.ServiceCharge) == false || sharedService.checkIsWholeNumber(loan.SettlementCharges.Stamp) == false || sharedService.checkIsWholeNumber(loan.SettlementCharges.HandlingCharge) == false)) {
            <button class="btn btn-primary ms-1" (click)="confirmBeforeMoveCents()">Cents to Interest</button>
          }

          @if (loan.IsEPF == true && loan.LegacySettlement == undefined) {
            <button class="btn btn-primary ms-1" (click)="openAddLegacySettlement(loan)">Add Settlement</button>
          }
          @if (loan.IsEPF == true && loan.LegacySettlement != undefined && sharedService.isBossAccount() == true) {
            <button class="btn btn-danger" (click)="confirmBeforeDeleteLegacySettlement(loan.ID)"><i class="fas fa-times"></i></button>
          }
        </div>
      }
      <hr class="full-width-grid-item m-0" />
      <div [style.color]="setBalanceColor(loan.Balance)" class="fw-bold">
        BALANCE :RM {{ loan.Balance }}
        <span [hidden]="loan.Scheme === 'A' || loan.Scheme === 'HUTANG'">({{ loan.Balance / loan.MonthlyPayment | number: "1.0-0" }} terms)</span>
        @if (isNonSettledEPFLoan() == true) {
          <i class="far fa-question-circle ms-2" placement="top" [ngbTooltip]="earlySettlementTooltip" style="cursor: pointer"></i>
        }
      </div>
      @if (!(loan.Scheme === SCHEME.HUTANG && isCP(loan.Status))) {
        <div style="color: blue; font-weight: bold">
          INTEREST CHARGED: RM {{ loan.InterestCharge + loan.ArrearPaid + loan.MonthlyInterest + loan.Discount }}
          <i class="far fa-question-circle ms-2" placement="top" [ngbTooltip]="tooltipContent" style="cursor: pointer"></i>
        </div>
      }
      @if (isSimplifiedView === false) {
        <div style="color: black; font-weight: bold">
          @if (loan.Scheme !== SCHEME.EPF) {
            ARREAR :{{ loan.Arrear }} time(s)
          }
        </div>
        <div>
          @if (sharedService.isRoles([enums.BOSS, enums.FINANCE, enums.BRANCH_MANAGER, enums.BOOKKEEPING_STAFF])) {
            <div class="badge rounded-pill" [ngClass]="getIfEarning(calculateProfitAndLoss(loan))">RM {{ calculateProfitAndLoss(loan) | number: "1.2-2" }}</div>
          }
        </div>
      }
      @if (sharedService.isRoles([enums.BOSS, enums.ADMIN])) {
        <div class="full-width-grid-item">
          <button class="btn btn-secondary" (click)="openMoveLoanModal()"><i class="fas fa-arrows-alt"></i> Move Loan</button>
        </div>
      }
    </div>

    <!-- <button mat-fab color="warn" aria-label="Pay" style="float: right;" *ngIf="loan.Status!='SETTLED'"
    (click)="openPaymentModal(loan.ID, loan.ReceiptNumber);$event.stopPropagation()">
    <i class="fas fa-dollar-sign"></i>
  </button> -->

    <div class="fab-container">
      @if (isSimplifiedView === false) {
        <button mat-fab class="text-bg-danger" (click)="fabOpen = !fabOpen">
          <i class="fas fa-caret-down"></i>
        </button>
      }
      @if (fabOpen) {
        <div class="fab-group">
          @if (isCP(loan.Status) == false && isSimplifiedView == false) {
            <div class="badge text-bg-dark">{{ loan.ID }}</div>
            <button mat-mini-fab (click)="openLoanDetailsModal(loan)" #tooltip="matTooltip" matTooltip="Loan Transaction" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
              <i class="fas fa-history"></i>
            </button>
            @if (sharedService.isRoles([enums.BRANCH_MANAGER, enums.BOOKKEEPING_STAFF, enums.STAFF]) && selectedProfile.SharedProfileId === undefined && !(isSettled(loan.Status) == true && loan.Scheme === "HUTANG")) {
              <button mat-mini-fab (click)="openPaymentModal(loan)" #tooltip="matTooltip" matTooltip="Payment" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
                <i class="fas fa-dollar-sign"></i>
              </button>
            }
            <!--
          * only show pay by simpan button for operating user
          * for normal active EPF loan, cannot use pay by simpan
          * allow to use this function for all SETTLED LOAN because can use simpan to pay interest charge
          -->
            @if (sharedService.isRoles([enums.BRANCH_MANAGER_HEAD, enums.BRANCH_MANAGER, enums.BOOKKEEPING_STAFF, enums.STAFF]) && ((loan.Scheme !== "EPF" && loan.IsEPF == false) || isSettled(loan.Status) == true)) {
              <button mat-mini-fab (click)="openPayWithReserveModal(loan, loan.MonthlyPayment)" #tooltip="matTooltip" matTooltip="Pay by Simpan" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
                <i class="fas fa-piggy-bank"></i>
              </button>
            }
            @if (sharedService.isRoles([enums.ADMIN, enums.BOSS, enums.BRANCH_MANAGER, enums.BOOKKEEPING_STAFF]) && (selectedProfile.SharedProfileId == undefined || selectedProfile.SharedProfileId == selectedProfile.ID)) {
              <button mat-mini-fab (click)="openAddCommissionModal(loan)" #tooltip="matTooltip" matTooltip="Manage Commission" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
                <i class="fas fa-gift"></i>
              </button>
            }
            <button mat-mini-fab (click)="openLoanArrear(loan)" #tooltip="matTooltip" matTooltip="Loan Arrears" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
              <i class="fas fa-book-dead"></i>
            </button>
            @if (sharedService.isBossAccount()) {
              <button mat-mini-fab (click)="openChangeStatusModal(loan)" #tooltip="matTooltip" matTooltip="Change Status" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
                <i class="fas fa-user-edit"></i>
              </button>
            }
          } @else {
            <button mat-mini-fab (click)="openLoanDetailsModal(loan)" #tooltip="matTooltip" matTooltip="Loan Transaction" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
              <i class="fas fa-history"></i>
            </button>
            <button mat-mini-fab (click)="openPaymentForBadDebt(loan)" #tooltip="matTooltip" matTooltip="Simpan Bad Debt" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
              <i class="fas fa-hand-holding-usd"></i>
            </button>
            <button mat-mini-fab (click)="openPaymentModal(loan)" #tooltip="matTooltip" matTooltip="Payment" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
              <i class="fas fa-dollar-sign"></i>
            </button>
            @if (sharedService.isRoles([enums.BRANCH_MANAGER, enums.BOOKKEEPING_STAFF])) {
              <button mat-mini-fab (click)="openPayWithReserveModal(loan, loan.MonthlyPayment)" #tooltip="matTooltip" matTooltip="Pay by Simpan" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
                <i class="fas fa-piggy-bank"> </i>
              </button>
            }
            @if (sharedService.isRoles([enums.BOSS, enums.ADMIN])) {
              <button mat-mini-fab (click)="confirmBeforeRemoveCP()" #tooltip="matTooltip" matTooltip="Remove From CP" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
                <i class="fas fa-user-times"></i>
              </button>
            }
          }
        </div>
      }
    </div>

    <!--try floating action button-->

    <div class="fixed-action-btn d-none">
      @if (isCP(loan.Status) == false && isSimplifiedView == false) {
        <a class="btn-floating btn-large red">
          <i class="fas fa-caret-down"></i>
        </a>
        <ul>
          <li>
            <span class="badge text-bg-dark" style="color: white">{{ loan.ID }}</span>
          </li>
          <li>
            <a class="btn-floating red" (click)="openLoanDetailsModal(loan)" #tooltip="matTooltip" matTooltip="Loan Transaction" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
              <i class="fas fa-history"></i>
            </a>
          </li>
          <li [hidden]="(isSettled(loan.Status) == true && loan.Scheme === 'HUTANG') || sharedService.isAdmin() == true || sharedService.isAuditor() == true || sharedService.isBossAccount() == true || sharedService.isFinance() || selectedProfile.SharedProfileId != undefined">
            <!-- <li [hidden]="isSettled(loan.Status)==true"> -->
            <a class="btn-floating yellow darken-1" (click)="openPaymentModal(loan)" #tooltip="matTooltip" matTooltip="Payment" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
              <i class="fas fa-dollar-sign"></i>
            </a>
          </li>
          @if (sharedService.isAdmin() == false && sharedService.isBossAccount() == false && !sharedService.isFinance() && sharedService.isAuditor() == false && ((loan.Scheme !== "EPF" && loan.IsEPF == false) || isSettled(loan.Status) == true)) {
            <li>
              <a class="btn-floating green" (click)="openPayWithReserveModal(loan, loan.MonthlyPayment)" #tooltip="matTooltip" matTooltip="Pay by Simpan" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black"><i class="fas fa-piggy-bank"> </i> </a>
            </li>
          }
          @if ((sharedService.isAdmin() || sharedService.isBossAccount() || sharedService.isBranchAccountHandler() == true) && (selectedProfile.SharedProfileId == undefined || selectedProfile.SharedProfileId == selectedProfile.ID)) {
            <li>
              <a class="btn-floating purple" (click)="openAddCommissionModal(loan)" #tooltip="matTooltip" matTooltip="Manage Commission" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
                <i class="fas fa-gift"></i>
              </a>
            </li>
          }
          <li>
            <a class="btn-floating blue" (click)="openLoanArrear(loan)" #tooltip="matTooltip" matTooltip="Loan Arrears" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
              <i class="fas fa-book-dead"></i>
            </a>
          </li>
          <li [hidden]="sharedService.isBossAccount() == false">
            <a class="btn-floating gray darken-1" (click)="openChangeStatusModal(loan)" #tooltip="matTooltip" matTooltip="Change Status" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
              <i class="fas fa-user-edit"></i>
            </a>
          </li>
        </ul>
      } @else {
        @if (isSimplifiedView == false) {
          <a class="btn-floating btn-large green">
            <i class="fas fa-caret-down"></i>
          </a>
        }
        <ul>
          <li>
            <a class="btn-floating red" (click)="openLoanDetailsModal(loan)" #tooltip="matTooltip" matTooltip="Loan Transaction" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
              <i class="fas fa-history"></i>
            </a>
          </li>
          <li>
            <a class="btn-floating blue" (click)="openPaymentForBadDebt(loan)" #tooltip="matTooltip" matTooltip="Simpan Bad Debt" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
              <i class="fas fa-hand-holding-usd"></i>
            </a>
          </li>
          <li [hidden]="loan.Scheme === 'HUTANG' && loan.Balance == 0">
            <a class="btn-floating red darken-1" (click)="openPaymentModal(loan)" #tooltip="matTooltip" matTooltip="Payment" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black"><i class="fas fa-dollar-sign"></i> </a>
          </li>
          @if (sharedService.isBranchAccountHandler() == true) {
            <li>
              <a class="btn-floating green" (click)="openPayWithReserveModal(loan, loan.MonthlyPayment)" #tooltip="matTooltip" matTooltip="Pay by Simpan" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black"><i class="fas fa-piggy-bank"> </i> </a>
            </li>
          }
          @if (sharedService.isAdmin() == true || sharedService.isBossAccount() == true) {
            <li>
              <a class="btn-floating purple" (click)="confirmBeforeRemoveCP()" #tooltip="matTooltip" matTooltip="Remove From CP" matTooltipPosition="right" matTooltipHideDelay="1000" matTooltipClass="tooltip-black">
                <i class="fas fa-user-times"></i>
              </a>
            </li>
          }
        </ul>
      }
    </div>
  </div>
</div>

<ng-template #settlementDetailsTooltip>
  <div class="fs-5 mb-3">RM {{ sharedService.calculateEPFSettlementAmount(loan.Principal, loan.InterestRate, loan.Term) | number: "1.0-2" }}</div>
  @if (loan.HasSettlementChargesObj) {
    <div class="mb-2">Charges Handling: RM{{ loan.SettlementCharges.HandlingCharge | number: "1.0-2" }}</div>
    <div class="mb-2">Charges DL: RM{{ loan.SettlementCharges.Extras / loan.Term | number: "1.0-2" }} x {{ loan.Term | number: "1.0-2" }} = RM{{ loan.SettlementCharges.Extras | number: "1.0-2" }}</div>
    <div class="mb-2">Charges Stamp: RM{{ loan.SettlementCharges.Stamp / loan.Term | number: "1.0-2" }} x {{ loan.Term | number: "1.0-2" }} = RM{{ loan.SettlementCharges.Stamp | number: "1.0-2" }}</div>
    <div class="mb-2">Charges SC: RM{{ loan.SettlementCharges.ServiceCharge / loan.Term | number: "1.0-2" }} x {{ loan.Term | number: "1.0-2" }} = RM{{ loan.SettlementCharges.ServiceCharge | number: "1.0-2" }}</div>
  } @else {
    <div class="mb-2">Settlement DL: RM{{ loan.SettlementExtra | number: "1.0-2" }}</div>
    <div class="mb-2">Settlement Stamp: RM{{ loan.SettlementStamp | number: "1.0-2" }}</div>
    <div class="mb-2">Settlement SC: RM{{ loan.SettlementServiceCharge | number: "1.0-2" }}</div>
  }
</ng-template>

<ng-template #earlySettlementTooltip>
  <p class="text-start">Settle on {{ sharedService.getTodayDate() | date: "dd-MM-yyyy" }}: RM {{ loan.EarlySettlementAmount | number: "1.2-2" }}</p>
</ng-template>

<ng-template #tooltipContent>
  <div>
    <p class="p-0 m-0">
      <small>Monthly Interest :RM {{ loan.MonthlyInterest }}</small>
    </p>
    <p class="p-0 m-0">
      <small>Interest Charge :RM {{ loan.InterestCharge }}</small>
    </p>
    <p class="p-0 m-0">
      <small>Arrear Charges :RM {{ loan.ArrearPaid }}</small>
    </p>
    <p class="p-0 m-0">
      <small>Discount :RM {{ loan.Discount }}</small>
    </p>
  </div>
</ng-template>

<ng-template #addLoanDoc let-data>
  <div class="d-flex justify-content-end mb-3">
      <button class="btn btn-dark" (click)="openUploadLoanDocModal(data.loanId)">Add More Loan Doc</button>
  </div>
</ng-template>
